export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const LOGIN_CLEAR = "LOGIN_CLEAR"
export const LOGIN_CANCEL = "LOGIN_CANCEL"
export const LOGOUT = "LOGOUT"
export const LOGIN_REFRESH = "LOGIN_REFRESH"
export const FACEBOOK_LOGIN_REQUEST = "FACEBOOK_LOGIN_REQUEST"
